<template lang="html">
  <v-dialog v-model="dialogAddImage" max-width="500px" persistent max-height="500px" style="overflow-y: hidden; border-radius: 20px !important;">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai">
            <v-layout row wrap>
              <v-icon color="white">fas fa-images</v-icon>&nbsp;&nbsp;
              <p class="mb-0" style="font-size: 16px;">{{$t('Dialog.album.headerAddImage')}}</p>
            </v-layout>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon flat @click="closeDialog">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text class="" style="height: 500px !important; overflow-y: hidden;">
        <v-layout row wrap justify-center align-center>
          <v-icon>fas fa-images</v-icon>
          <v-text-field
            v-model="albumsname"
            name="albums_name"
            :label="$t('Dialog.album.nameAlbum')"
            id="id"
            class="ml-2"
          ></v-text-field>
          <v-btn class="btnalbums text-transform" @click="create_albums()" :loading="loading" flat :disabled="albumsname == ''">{{$t('Dialog.album.headerCreate')}}</v-btn>
        </v-layout>
        <v-layout row wrap style="height: 500px; overflow-y: scroll;">
          <v-list two-line style="width: 100% !important;" v-if="listalbum.length != 0">
            <template v-for="(item, index) in listalbum" style="height: 500px !important;">
              <v-list-tile
                :key="item.title"
                avatar
                ripple
                style="cursor: pointer;"
                v-if="item.state['status'] !== 'delete'"
              >
                <v-list-tile-content>
                  <v-layout row wrap v-for="(image, index) in item.information">
                    <img :src="image.link"  style="padding: 10px; height: 80px; border-radius: 15px;" width="80px" v-if="image.status == 'active' && index === 0">
                    <img src="/static/img/icons/image.png" alt="" v-else-if="index === 0 && image.status == 'delete'" width="80px">
                  </v-layout>
                </v-list-tile-content>
                <v-list-tile-content @click="addimage_albums(item._id, item.albums_name)">
                  <v-list-tile-title v-if="item.albums_name !== ''">{{ item.albums_name }}</v-list-tile-title>
                  <v-list-tile-title v-else>{{ date(item.create_date) }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>

                </v-list-tile-action>

              </v-list-tile>
              <v-divider
                v-if="index + 1 < listalbum.length && item.state['status'] !== 'delete'"
                :key="index"
              ></v-divider>
            </template>
          </v-list>
          <v-layout row wrap justify-center v-else>
            <h4>{{$t('Dialog.album.noDataAlbum')}}</h4>
          </v-layout>
        </v-layout>
      </v-card-text>
    </v-card>
    <!-- <CreateAlbumsDialog :dialogCreatealbums="dialogCreatealbums" :path_pic_albums="path_pic_albums" @closeCreatealbums="closeCreatealbums"></CreateAlbumsDialog> -->

  </v-dialog>
</template>

<script>
import {
  Momenttime,
  Decode
} from '@/services'
import {
  sync
} from 'vuex-pathify'
// import CreateAlbumsDialog from '@/components/chat/dialog/albums/CreateAlbumsDialog'
export default {
  props: {
    dialogAddImage: false,
    path_pic_albums: '',
    file_name: ''
  },
  components: {
    // CreateAlbumsDialog
  },
  computed: {
    ...sync('*')
  },
  data: () => ({
    tokenuser: '',
    tokenroom: '',
    listalbum: [],
    filter_infoalbum: [],
    lastindex_image: [],
    image_last: [],
    albumsname: '',
    loading: false,
    information_image: []
    // dialogCreatealbums: false
  }),
  created() {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.tokenuser = decoded['tokenuser']
    this.tokenroom = this.$route.params.roomid
  },
  methods: {
    // closeCreatealbums(value) {
    //   this.dialogCreatealbums = value
    // },
    closeDialog () {
      this.$emit('closeAddImage', false)
      this.$emit('path_pic_albums', '')
    },
    date(timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    time(timestamp) {
      return Momenttime.momenttimethai(timestamp)
    },
    addimage_albums(albums_id, albums_name) {
      // console.log(albums_id)
      this.$swal({
        // title: 'เพิ่มรูปในอัลบั้ม',
        // text: 'คุณต้องการเพิ่มรูปในอัลบั้ม ' + albums_name + ' ใช่หรือไม่?',
        text: this.$t('Alert.Album.textAddImageAlbum', { name: albums_name } ),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/addimage_chatroom_to_albums', {
            path_imgs: this.path_pic_albums,
            tokenuser: this.tokenuser,
            tokenroom: this.tokenroom,
            albums_id: albums_id
          }).then((response) => {
            // console.log(response.data.data)
            this.$swal('', this.$t('Alert.Success.savePhotoAlbum'), 'success')
            this.closeDialog()
          }).catch((err) => {
            console.log(err)
          })
        }
      })
    },
    create_albums () {
      this.loading = true
      this.axios.post(process.env.APIpub + '/addimage_chatroom_to_albums', {
        path_imgs: this.path_pic_albums,
        tokenuser: this.tokenuser,
        tokenroom: this.tokenroom,
        albums_name: this.albumsname
      }).then((response) => {
        this.loading = false
        this.albumsname = ''
        this.$swal('', this.$t('Alert.Success.createAlbum'), 'success')
        this.$emit('closeAddImage', false)
      }).catch((err) => {
        this.loading = false
        this.albumsname = ''
        // this.$swal('', 'ไม่สามารถสร้างอัลบั้มได้ กรุณาลองใหม่ภายหลัง', 'error')
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        console.log(err)
      })
    }
  },
  watch: {
    dialogAddImage () {
      // console.log(this.path_pic_albums)
      this.tokenroom = this.$route.params.roomid
      if (this.dialogAddImage) {
        this.axios.post(process.env.APIpub + '/getlist_albums', {tokenroom: this.tokenroom, tokenuser: this.tokenuser}).then((response) => {
          // console.log(response.data.data)
          this.listalbum = response.data.data
          // console.log(this.listalbum)
          for (var i = 0; i < this.listalbum.length; i++) {
            // console.log(this.listalbum[i]['information'])
            this.lastindex_image[i] = _.findLastIndex(this.listalbum[i].information, function(o) { return o.status == 'active' })
            // this.image_last[i] = this.listalbum[this.lastindex_image[i]].information
            // this.filter_infoalbum[i] = _.filter(this.listalbum[i].information, function (information) { return information.status === 'active' })
          }
          // console.log(this.image_last)
          // this.filter_infoalbum = _.filter(this.listalbum.information, function (information) { return information.status === 'active' })
        }).catch((error) => {
          if (error.response.data.status === 'fail') {
            console.log(error)
          }
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>
.text-transform {
  text-transform: none;
}
.btnalbums {
  width: 100px !important;
  /* border-style: solid !important; */
  border-radius: 20px !important;
  border-width: thin !important;
  border-color: inherit !important;
  background-color: #2196f3 !important;
  color: white !important;
}
>>>.v-dialog .v-dialog--active .v-dialog--persistent {
  border-radius: 20px !important;
}
>>>.v-list .v-list--two-line .theme--light {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/AddImageDialogMobile.vue